import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

// Finished well is green, stuck or failed needs a person, working is blue, not started is neutral.
const TONE = {
  published: 'ok',
  waiting_asset: 'warn',
  revision_requested: 'warn',
  build_failed: 'danger',
  google_play_rejected: 'danger',
  rejected: 'danger',
  design: 'accent',
  custom_development: 'accent',
  internal_review: 'accent',
  google_play_review: 'accent',
};

export default function StatusBadge({ status }) {
  const { language } = useLanguage();
  const t = translations[language];
  const tone = TONE[status];
  return <span className={`chip status-chip${tone ? ` chip--${tone}` : ''}`}>{t.statusLabel[status] || status}</span>;
}
